import { useDispatch } from 'react-redux';
import { getPortInAvailability, getTrunkGroupList } from '../../../actions/Inteliquent';
import React, { useState, useMemo, useEffect } from 'react';
import { Input, Button } from 'reactstrap';
import { useForm } from 'react-hook-form';
import Table from '../../../components/Table';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
const OPTIONS = {
  shouldValidate: true,
  shouldDirty: true,
  shouldTouch: true,
};
function CheckServiceAvailability() {
  const token = localStorage.getItem('jwtToken') || null;
  const dispatch = useDispatch();
  const history = useHistory();
  const [searchBy, setSearchBy] = useState('numbers');
  const [data, setData] = useState([]);
  const [trunkgroups, setTrunkGroups] = useState([]);

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors, submitCount, isSubmitted, isValid },
  } = useForm({
    defaultValues: {
      areaCode: '',
      exchangeFrom: '',
      exchangeTo: '',
      numbers: '',
      prefix: '',
      searchBy: 'numbers',
      trunk: '',
    },
  });

  useEffect(() => {
    if (isSubmitted && !isValid) {
      console.log(errors, getValues());
      toast.error('Please fix error and submit again');
    }
  }, [submitCount]);
  useEffect(() => {
    getTrunkList();
  }, []);
  const getTrunkList = async () => {
    const res = await dispatch(getTrunkGroupList(token));
    if (res?.status != 'Success') toast.error('Error Fetching Trunk Group List');
    var { default: defaultValue, trunkGroupList } = res || {};
    setValue('trunk', defaultValue, OPTIONS);
    if (!Array.isArray(trunkGroupList)) trunkGroupList = [];
    var find = trunkGroupList.find(group => group.trunkGroupName == defaultValue);
    if (!find) trunkGroupList = [...trunkGroupList, { trunkGroupName: defaultValue }];
    setTrunkGroups(trunkGroupList);
    // Promise.all([trunk]).then(([res]) => {
    //   alert(JSON.stringify(res));
    // });
  };
  const column = useMemo(
    () => [
      {
        dataIndex: 'telephoneNumber',
        label: 'Telephone Number',
        sort: (a, b) => a.telephoneNumber - b.telephoneNumber,
      },
      {
        dataIndex: 'serviceProviderName',
        label: 'Carrier',
      },
      {
        dataIndex: 'localRoutingNumber',
        label: 'LRN',
      },
      {
        dataIndex: 'isPortable',
        label: 'Portable',
        render: value => (value ? 'True' : 'False'),
        sort: (a, b) => a.isPortable - b.isPortable,
      },
      {
        dataIndex: 'notPortableReason',
        label: 'Not Portable Reason',
      },
    ],
    [data],
  );

  async function getResult(searchBy, values) {
    let body = {};

    if (searchBy === 'numbers') {
      const { numbers, trunk } = values;
      body = {
        mode: 'numbers',
        range: [],
        queryNumbers: numbers.map(number => {
          return { tn: number, trunkGroup: trunk };
        }),
      };
    } else {
      const { areaCode, prefix, exchangeFrom, exchangeTo } = values;
      body = {
        mode: 'range',
        range: [
          {
            areaCode: areaCode,
            prefix: prefix,
            exchangeFrom: exchangeFrom,
            exchangeTo: exchangeTo,
          },
        ],
        queryNumbers: [],
      };
    }

    return await dispatch(getPortInAvailability(token, body));
  }

  async function onSearch() {
    const loading = toast.info('Loading', { autoClose: 5000 });
    getResult(getValues().searchBy, getValues())
      .then(({ serviceAvailable }) => setData(serviceAvailable))
      .catch(console.error)
      .finally(() => toast.dismiss(loading));
  }

  return (
    <div>
      <div className="float-right">
        <Button className="mr-2" onClick={() => history.push('/provisioning/porting')}>
          Close
        </Button>
      </div>

      <form className="shadow-none" onSubmit={handleSubmit(onSearch)}>
        <div className="h3 font-weight-bold">
          Search For Telephone Number Porting Service Availability
        </div>
        <div>
          <label className="pl-4">
            <Input
              onClick={() => {
                setSearchBy('numbers');
                setValue('searchBy', 'numbers', {
                  shouldDirty: true,
                  shouldTouch: true,
                  shouldValidate: true,
                });
              }}
              type="radio"
              value="numbers"
              defaultChecked={searchBy === 'numbers'}
              {...register('searchBy', { required: 'This is required' })}
            />
            Enter Telephone Numbers
          </label>
          <label className="pl-4 ml-4">
            <Input
              onClick={() => {
                setSearchBy('range');
                setValue('searchBy', 'range', {
                  shouldDirty: true,
                  shouldTouch: true,
                  shouldValidate: true,
                });
              }}
              type="radio"
              value="range"
              defaultChecked={searchBy === 'range'}
              {...register('searchBy', { required: 'This is required' })}
            />
            Enter Line Range
          </label>
        </div>
        {searchBy === 'numbers' ? (
          <>
            <label className="my-3 col-lg-8 p-0">
              <span className="d-block h4 font-weight-bold">Telephone Numbers</span>
              <Input
                {...register('numbers', {
                  validate: value =>
                    (searchBy === 'numbers' && value?.length) || 'This is required',
                })}
                onChange={e =>
                  setValue(
                    'numbers',
                    e.target.value.split(/,| |;|\n/).filter(e => e != undefined && e != ''),
                    {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,
                    },
                  )
                }
                type="textarea"
                className="w-auto"
                rows="10"
                style={{ minWidth: '500px' }}
              />
            </label>
            {errors?.numbers && (
              <div className="text-danger font-weight-bold">{errors.numbers.message}</div>
            )}
            <div className="my-3">
              <div className="font-weight-bolder">Instructions</div>
              <div>
                Paste or Manually enter telephone numbers, separated by characters such as space,
                comma, semicolon, or paragraph return
              </div>
            </div>
          </>
        ) : (
          <div className="my-3">
            <div className="h4 font-weight-bold">Telephone Numbers Range</div>
            <div className="row">
              <label className="col-auto">
                <span className="d-block">Area Code</span>
                <Input
                  {...register('areaCode', {
                    validate: value => (searchBy === 'range' && value !== '') || 'This is required',
                  })}
                  onChange={e =>
                    setValue('areaCode', e.target.value, {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,
                    })
                  }
                  type="number"
                />
                {errors?.areaCode && (
                  <span className="d-block text-danger font-weight-bold">
                    {errors.areaCode.message}
                  </span>
                )}
              </label>
              <label className="col-auto">
                <span className="d-block">prefix</span>
                <Input
                  {...register('prefix', {
                    validate: value => (searchBy === 'range' && value !== '') || 'This is required',
                  })}
                  onChange={e =>
                    setValue('prefix', e.target.value, {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,
                    })
                  }
                  type="number"
                />
                {errors?.prefix && (
                  <span className="d-block text-danger font-weight-bold">
                    {errors.prefix.message}
                  </span>
                )}
              </label>
              <label className="col-auto">
                <span className="d-block">Exchange</span>
                <Input
                  {...register('exchangeFrom', {
                    validate: value => (searchBy === 'range' && value !== '') || 'This is required',
                  })}
                  onChange={e =>
                    setValue('exchangeFrom', e.target.value, {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,
                    })
                  }
                  type="number"
                />
                {errors?.exchangeFrom && (
                  <span className="d-block text-danger font-weight-bold">
                    {errors.exchangeFrom.message}
                  </span>
                )}
              </label>
              <div className="col-auto pt-4">To</div>
              <label className="col-auto">
                <span className="d-block">Exchange</span>
                <Input
                  {...register('exchangeTo', {
                    validate: value => (searchBy === 'range' && value !== '') || 'This is required',
                  })}
                  onChange={e =>
                    setValue('exchangeTo', e.target.value, {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,
                    })
                  }
                  type="number"
                />
                {errors?.exchangeTo && (
                  <span className="d-block text-danger font-weight-bold">
                    {errors.exchangeTo.message}
                  </span>
                )}
              </label>
            </div>
          </div>
        )}

        <label className="my-3 col-lg-8 p-0 d-flex align-items-center">
          <span>Trunk Group</span>
          <Input
            type="select"
            className="w-auto ml-2"
            onChange={e => setValue('trunk', e.target.value, OPTIONS)}
          >
            {trunkgroups.map((group, index) => (
              <option key={group.trunkGroupName} value={group.trunkGroupName}>
                {group.trunkGroupName}
              </option>
            ))}
          </Input>
        </label>
        {errors?.trunk && (
          <div className="text-danger font-weight-bold">{errors.trunk.message}</div>
        )}

        <div className="text-right">
          {!!data?.length && (
            <>
              <Button
                type="button"
                color="primary"
                className="mr-2"
                onClick={() => {
                  const portableNumbers = data.reduce((acc, item) => {
                    if (item.isPortable) acc.push(item.telephoneNumber);
                    return acc;
                  }, []);
                  if (portableNumbers.length)
                    history.push(
                      `/provisioning/porting/create-order?tnOptions=${portableNumbers}&trunkGroup=${
                        getValues().trunk
                      }`,
                    );
                  else toast.error('No Portable Number To Create Order From');
                }}
              >
                Create An Order From Portable Numbers
              </Button>
              <Button type="button" className="mr-2" onClick={() => setData([])}>
                Clear Search
              </Button>
            </>
          )}
          <Button type="submit" color="primary">
            Search
          </Button>
        </div>
      </form>

      {!!data?.length && (
        <div>
          <div className="h4 font-weight-bold">Search Results</div>
          <Table data={data} column={column} />
        </div>
      )}
    </div>
  );
}

export default CheckServiceAvailability;
